import { render, staticRenderFns } from "./CertListView.vue?vue&type=template&id=6caedd5b&scoped=true"
import script from "./CertListView.vue?vue&type=script&lang=js"
export * from "./CertListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caedd5b",
  null
  
)

export default component.exports